// firebase.js
import { initializeApp, getApps } from "firebase/app";
import { getFirestore, doc, setDoc, getDoc, arrayUnion, updateDoc, arrayRemove } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCDzt0rwTrUlFlDUFTQL5y-zPSZddI8hFQ",
  authDomain: "://firebaseapp.com",
  projectId: "finaltouch-e8414",
  storageBucket: "finaltouch-e8414.firebasestorage.app",
  messagingSenderId: "757359428029",
  appId: "1:757359428029:web:b1ba6dc7edad5efcb712d4"
};

const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];
const db = getFirestore(app);

export function initFirebase() { return app; }

// --- MASTER CATEGORY LIST FUNCTIONS ---

export const addCategoryToFirebase = async (newCategory) => {
  try {
    const categoryRef = doc(db, "settings", "categories");
    await setDoc(categoryRef, { list: arrayUnion(newCategory) }, { merge: true });
  } catch (err) { console.error(err); throw err; }
};

export const getCategoriesFromFirebase = async () => {
  try {
    const categoryRef = doc(db, "settings", "categories");
    const snap = await getDoc(categoryRef);
    return snap.exists() ? snap.data().list || [] : [];
  } catch (err) { return []; }
};

export const removeCategoryFromFirebase = async (categoryName) => {
  try {
    const categoryRef = doc(db, "settings", "categories");
    await updateDoc(categoryRef, { list: arrayRemove(categoryName) });
  } catch (err) { console.error(err); throw err; }
};

// ✅ NEW: Permanently Rename a Category in the Dropdown List
export const renameCategoryInFirebase = async (oldName, newName) => {
  try {
    const categoryRef = doc(db, "settings", "categories");
    const snap = await getDoc(categoryRef);
    if (snap.exists()) {
      const list = snap.data().list || [];
      const updatedList = list.map(item => item === oldName ? newName : item);
      await setDoc(categoryRef, { list: updatedList }, { merge: true });
    }
  } catch (err) { console.error(err); throw err; }
};

// --- DAILY TASKS FUNCTIONS ---

export const saveTaskToFirebase = async (taskData) => {
  try {
    const today = new Date().toISOString().split('T')[0];
    const taskRef = doc(db, "dailyLearning", today);
    await setDoc(taskRef, {
      tasks: arrayUnion({ ...taskData, id: Date.now(), time: new Date().toLocaleTimeString() })
    }, { merge: true });
  } catch (err) { console.error(err); throw err; }
};

export const getTodayTasks = async () => {
  try {
    const today = new Date().toISOString().split('T')[0];
    const taskRef = doc(db, "dailyLearning", today);
    const snap = await getDoc(taskRef);
    return snap.exists() ? snap.data().tasks : [];
  } catch (err) { return []; }
};

export const deleteTaskFromFirebase = async (taskId) => {
  try {
    const today = new Date().toISOString().split('T')[0];
    const taskRef = doc(db, "dailyLearning", today);
    const snap = await getDoc(taskRef);
    if (snap.exists()) {
      const tasks = snap.data().tasks.filter(t => t.id !== taskId);
      await setDoc(taskRef, { tasks });
    }
  } catch (err) { console.error(err); throw err; }
};

export const updateTaskInFirebase = async (updatedTask) => {
  try {
    const today = new Date().toISOString().split('T')[0];
    const taskRef = doc(db, "dailyLearning", today);
    const snap = await getDoc(taskRef);
    if (snap.exists()) {
      const tasks = snap.data().tasks.map(t => t.id === updatedTask.id ? updatedTask : t);
      await setDoc(taskRef, { tasks });
    }
  } catch (err) { console.error(err); throw err; }
};

export { db };
